export default {
  path: '*',
  name: 'zNotFound',
  redirect: {
    name: '404',
  },
};
